import { render } from "./EmployeeDetail.vue?vue&type=template&id=b964f0d8"
import script from "./EmployeeDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeDetail.vue?vue&type=script&lang=js"

import "./EmployeeDetail.vue?vue&type=style&index=0&id=b964f0d8&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__